import React from "react";

const Blog3 = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1 data-aos="fade" className="text-main-black text-34 font-semibold w-full text-center max-w-[420px]">
                Simplify Your Health Journey with Wellness OPD
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto w-full">
          <div className="grid grid-cols-6 md:grid-cols-12 items-center">
            <div className="col-span-6">
              <h1 className="text-24 sm:text-34 leading-[55px] tracking-tight font-semibold text-main-black">
                Overview
              </h1>
              <p className="max-w-[533px] text-16 sm:text-24 leading-[40px] text-paragraph mt-2.5 md:mt-3.5">
                Managing your health can often feel like a hassle — scheduling doctor’s appointments, running to labs for tests, or trying to find time to get a consultation with a specialist. Wellness OPD changes this by offering a simplified approach to healthcare, ensuring that you have access to all the services you need from the convenience of one platform.
              </p>
            </div>
            <div className="col-span-6 flex justify-center items-center mt-5 md:mt-0">
              <img
                src="assets/images/home-three/blogs/3.jpg"
                alt=""
                className="w-full rounded-[40px]"
              />
            </div>
          </div>
          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
           What Makes Wellness OPD Simple?
          </h4>
          <p className="text-paragraph mt-[10px]">
            Wellness OPD brings everything you need for routine health maintenance and preventive care into a single, easy-to-use package. Whether it’s a virtual doctor consultation, online lab test booking, or personalized health advice, Wellness OPD gives you the tools to manage your health remotely and efficiently.
          </p>
          <p className="text-paragraph mt-[10px]">
            You no longer need to juggle multiple appointments or waste time in long queues at clinics. With just a few clicks, you can access healthcare that fits into your busy lifestyle, all without leaving the comfort of your home or office.
          </p>
          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
           Streamlined Health Services at Your Fingertips
          </h4>
          <p className="text-paragraph mt-[10px] mb-[10px]">
           Here are a few of the services that make Wellness OPD the ideal choice for simplifying your healthcare:
          </p>
          <p className="text-paragraph">
           1. On-demand doctor consultations: Skip the waiting room and consult with top healthcare professionals whenever you need them.
          </p>
          <p className="text-paragraph">
           2. Diagnostic test bookings: Get lab tests done with ease, and receive quick results for faster treatment decisions.
          </p>
          <p className="text-paragraph">
           3. Chronic disease management: Continuous monitoring and guidance for chronic conditions like diabetes, hypertension, and more.
          </p>
          <p className="text-paragraph">
           4. Health reminders and follow-ups: Keep track of your appointments, medication schedules, and wellness goals effortlessly.
          </p>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
           Ideal for Busy Professionals and Families
          </h4>
          <p className="text-paragraph mt-[10px]">
           Wellness OPD is perfect for anyone with a packed schedule. Whether you’re a busy professional who can’t afford to take time off or a parent looking to keep your family’s health in check, Wellness OPD gives you the flexibility to access healthcare services on your terms. No more taking time off work or worrying about missing appointments.
          </p>
          <p className="text-paragraph mb-10 mt-[10px]">
            It’s also beneficial for seniors who need regular check-ups and chronic condition management but want to avoid the hassle of frequent hospital visits. Wellness OPD provides convenience, ensuring that your health remains a priority despite a busy lifestyle.
          </p>

          <h4 className="font-semibold text-[20px]  leading-[35px] tracking-tight text-main-black mt-10">
            Conclusion
          </h4>
          <p className="text-paragraph mb-10 mt-[10px]">
          With Wellness OPD, healthcare becomes simpler, more accessible, and more efficient. You can maintain your health effortlessly with affordable, on-demand services. Whether it’s a routine checkup or managing a health condition, Wellness OPD gives you the freedom to prioritize your well-being without disrupting your daily life.
          </p>
        </div>
      </section>
      {/* blog end  */}


    </main>
  );
};

export default Blog3;
